import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  getDashboardStatsRequest,
  getDashboardStatsRequestSuccess,
  getDashboardStatsRequestError,
} from "../../../slices/teams/members/GetDashboardStatsSlice";

export const GetDashboardStatsApi = () => async (dispatch) => {
  try {
    dispatch(getDashboardStatsRequest());
    const response = await axiosInstance.get(endpoints.dashboard);
    dispatch(getDashboardStatsRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status || error?.status,
    };
    dispatch(getDashboardStatsRequestError(_error));
    throw _error;
  }
};
